export default __webpack_public_path__ + "static/billPayment-27b29ccc998445ae9f7aeefb1347235b.mp4";